import React from 'react'
import { array } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './ScentOption.scss'

import bottleImage from './images/bottle.svg'


const ScentOption = ({ option: { scentCount } }) => (
  <div>
    <FormattedMessage className={s.title} tag="div" {...messages.title} values={{ count: scentCount }} />
    <div className={s.bottles}>
      {
        array.range(1, scentCount)
          .map(Number.call, Number)
          .map((num) => (
            <img key={num} className={s.bottle} src={bottleImage} alt="bottle" />
          ))
      }
    </div>
  </div>
)


export default ScentOption
